import { cssVars } from '@/lib/cssVars';
import { Icon } from './Icon';
import styles from './Sparkles.module.css';

/** Positions as percentages of the parent box, sizes in design units, delays in ms. */
const SPARKS = [
  { x: -30, y: -20, size: 9, delay: 0 },
  { x: 120, y: -35, size: 12, delay: 180 },
  { x: 140, y: 40, size: 7, delay: 420 },
  { x: -45, y: 70, size: 8, delay: 300 },
  { x: 50, y: -70, size: 10, delay: 540 },
  { x: 60, y: 130, size: 7, delay: 660 },
] as const;

/** Twinkling stars around the parent element; the parent must be positioned. */
export function Sparkles() {
  return (
    <span className={styles.root} aria-hidden>
      {SPARKS.map((s, i) => (
        <Icon
          key={i}
          name="sparkle"
          className={styles.spark}
          style={cssVars({
            '--x': `${s.x}%`,
            '--y': `${s.y}%`,
            '--size': s.size,
            '--delay': `${s.delay}ms`,
          })}
        />
      ))}
    </span>
  );
}
